import { atom } from 'nanostores'

export const searchValue = atom('')
export const setSearchValue = (value: string) => {
	searchValue.set(value)
}

export const pageSettings: Record<string, { display: boolean }> = {
	homePage: {
		display: false,
	},
	searchPage: {
		display: true,
	},
	detailPage: {
		display: true,
	},
}
